import type {
  IGetPrivacyCenterComponentsRequest,
  IGetPrivacyCenterContentResponse,
  TEntity,
  TUserType,
} from 'contexts/app-context/types'

import { privacyCenterContent as content_AR_AR_US_BRANCH_en_US } from './content/AR/AR/US_BRANCH/en-US'
import { privacyCenterContent as content_AR_AR_US_BRANCH_es_ES } from './content/AR/AR/US_BRANCH/es-ES'
import { privacyCenterContent as content_AR_AR_US_BRANCH_pt_BR } from './content/AR/AR/US_BRANCH/pt-BR'
import { privacyCenterContent as content_AR_PF_US_BRANCH_en_US } from './content/AR/PF/US_BRANCH/en-US'
import { privacyCenterContent as content_AR_PF_US_BRANCH_es_ES } from './content/AR/PF/US_BRANCH/es-ES'
import { privacyCenterContent as content_AR_PF_US_BRANCH_pt_BR } from './content/AR/PF/US_BRANCH/pt-BR'
import { privacyCenterContent as content_AR_PJ_US_BRANCH_en_US } from './content/AR/PJ/US_BRANCH/en-US'
import { privacyCenterContent as content_AR_PJ_US_BRANCH_es_ES } from './content/AR/PJ/US_BRANCH/es-ES'
import { privacyCenterContent as content_AR_PJ_US_BRANCH_pt_BR } from './content/AR/PJ/US_BRANCH/pt-BR'
import { privacyCenterContent as content_BR_MEI_BR_en_US } from './content/BR/MEI/BR/en-US'
import { privacyCenterContent as content_BR_MEI_BR_es_ES } from './content/BR/MEI/BR/es-ES'
import { privacyCenterContent as content_BR_MEI_BR_pt_BR } from './content/BR/MEI/BR/pt-BR'
import { privacyCenterContent as content_BR_MEI_US_BRANCH_en_US } from './content/BR/MEI/US_BRANCH/en-US'
import { privacyCenterContent as content_BR_MEI_US_BRANCH_es_ES } from './content/BR/MEI/US_BRANCH/es-ES'
import { privacyCenterContent as content_BR_MEI_US_BRANCH_pt_BR } from './content/BR/MEI/US_BRANCH/pt-BR'
import { privacyCenterContent as content_BR_PF_BR_en_US } from './content/BR/PF/BR/en-US'
import { privacyCenterContent as content_BR_PF_BR_es_ES } from './content/BR/PF/BR/es-ES'
import { privacyCenterContent as content_BR_PF_BR_pt_BR } from './content/BR/PF/BR/pt-BR'
import { privacyCenterContent as content_BR_PF_US_BRANCH_en_US } from './content/BR/PF/US_BRANCH/en-US'
import { privacyCenterContent as content_BR_PF_US_BRANCH_es_ES } from './content/BR/PF/US_BRANCH/es-ES'
import { privacyCenterContent as content_BR_PF_US_BRANCH_pt_BR } from './content/BR/PF/US_BRANCH/pt-BR'
import { privacyCenterContent as content_BR_PJ_BR_en_US } from './content/BR/PJ/BR/en-US'
import { privacyCenterContent as content_BR_PJ_BR_es_ES } from './content/BR/PJ/BR/es-ES'
import { privacyCenterContent as content_BR_PJ_BR_pt_BR } from './content/BR/PJ/BR/pt-BR'
import { privacyCenterContent as content_BR_PJ_US_BRANCH_en_US } from './content/BR/PJ/US_BRANCH/en-US'
import { privacyCenterContent as content_BR_PJ_US_BRANCH_es_ES } from './content/BR/PJ/US_BRANCH/es-ES'
import { privacyCenterContent as content_BR_PJ_US_BRANCH_pt_BR } from './content/BR/PJ/US_BRANCH/pt-BR'
import { privacyCenterContent as content_US_PF_US_BRANCH_en_US } from './content/US/PF/US_BRANCH/en-US'
import { privacyCenterContent as content_US_PF_US_BRANCH_es_ES } from './content/US/PF/US_BRANCH/es-ES'
import { privacyCenterContent as content_US_PF_US_BRANCH_pt_BR } from './content/US/PF/US_BRANCH/pt-BR'
import { privacyCenterContent as content_US_PJ_US_BRANCH_en_US } from './content/US/PJ/US_BRANCH/en-US'
import { privacyCenterContent as content_US_PJ_US_BRANCH_es_ES } from './content/US/PJ/US_BRANCH/es-ES'
import { privacyCenterContent as content_US_PJ_US_BRANCH_pt_BR } from './content/US/PJ/US_BRANCH/pt-BR'
import { privacyCenterContent as content_US_US_US_BRANCH_en_US } from './content/US/US/US_BRANCH/en-US'
import { privacyCenterContent as content_US_US_US_BRANCH_es_ES } from './content/US/US/US_BRANCH/es-ES'
import { privacyCenterContent as content_US_US_US_BRANCH_pt_BR } from './content/US/US/US_BRANCH/pt-BR'

const buildPrivacyCenterContentKey = ({
  country,
  accountType,
  entity,
  language,
}: IGetPrivacyCenterComponentsRequest) => `${country}|${accountType}|${entity}|${language}`

const privacyCenterContentByKey = {
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'AR',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_AR_AR_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'AR',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_AR_AR_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'AR',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_AR_AR_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_AR_PF_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_AR_PF_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_AR_PF_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_AR_PJ_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_AR_PJ_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'AR',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_AR_PJ_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'MEI',
    entity: 'BR',
    language: 'en-US',
  })]: content_BR_MEI_BR_en_US,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'MEI',
    entity: 'BR',
    language: 'es-ES',
  })]: content_BR_MEI_BR_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'MEI',
    entity: 'BR',
    language: 'pt-BR',
  })]: content_BR_MEI_BR_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'MEI',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_BR_MEI_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'MEI',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_BR_MEI_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'MEI',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_BR_MEI_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PF',
    entity: 'BR',
    language: 'en-US',
  })]: content_BR_PF_BR_en_US,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PF',
    entity: 'BR',
    language: 'es-ES',
  })]: content_BR_PF_BR_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PF',
    entity: 'BR',
    language: 'pt-BR',
  })]: content_BR_PF_BR_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_BR_PF_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_BR_PF_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_BR_PF_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PJ',
    entity: 'BR',
    language: 'en-US',
  })]: content_BR_PJ_BR_en_US,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PJ',
    entity: 'BR',
    language: 'es-ES',
  })]: content_BR_PJ_BR_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PJ',
    entity: 'BR',
    language: 'pt-BR',
  })]: content_BR_PJ_BR_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_BR_PJ_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_BR_PJ_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'BR',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_BR_PJ_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_US_PF_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_US_PF_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'PF',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_US_PF_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_US_PJ_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_US_PJ_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'PJ',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_US_PJ_US_BRANCH_pt_BR,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'US',
    entity: 'US_BRANCH',
    language: 'en-US',
  })]: content_US_US_US_BRANCH_en_US,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'US',
    entity: 'US_BRANCH',
    language: 'es-ES',
  })]: content_US_US_US_BRANCH_es_ES,
  [buildPrivacyCenterContentKey({
    country: 'US',
    accountType: 'US',
    entity: 'US_BRANCH',
    language: 'pt-BR',
  })]: content_US_US_US_BRANCH_pt_BR,
} as Record<string, IGetPrivacyCenterContentResponse<TEntity, TUserType>>

const getPrivacyCenterContentByKey = <Entity extends TEntity, UserType extends TUserType>({
  country,
  accountType,
  entity,
  language,
}: IGetPrivacyCenterComponentsRequest) => {
  const key = buildPrivacyCenterContentKey({ country, accountType, entity, language })
  return privacyCenterContentByKey[key] as
    | IGetPrivacyCenterContentResponse<Entity, UserType>
    | undefined
}

export { buildPrivacyCenterContentKey, getPrivacyCenterContentByKey, privacyCenterContentByKey }
